import React, {useEffect, useState} from "react";
import {useCountertops} from "../../contexts/countertopsContext";
import {CheckBox} from "devextreme-react/check-box";
import {NumberBox} from "devextreme-react/number-box";
import {Option} from "../../types/Option";
import {SelectedCustomOption} from "../../types/SelectedCustomOption";
import TextBox from "devextreme-react/text-box";
import Validator from "devextreme-react/validator";
import {RequiredRule} from "devextreme-react/form";

export function CustomOptionControl({prodQteGrpID, option, selectedOption, id, isLast}: {
    prodQteGrpID: number,
    option: Option,
    selectedOption: SelectedCustomOption | undefined
    id: number,
    isLast: boolean
}) {
    const context = useCountertops();
    const [checked, setChecked] = useState<boolean>(false);

    useEffect(() => {
        if (selectedOption === undefined) {
            setChecked(false);
        } else {
            setChecked(true);
        }
    }, [selectedOption])

    return (<tr key={option.productID}>
            <td style={{width: '30px', textAlign: "center"}}>
                <CheckBox
                    value={checked}
                    onValueChanged={(e) => {
                        if (e.event) {
                            if (e.value) {
                                context.addCustomOption(prodQteGrpID, option.productID);
                            } else {
                                context.removeCustomOption(prodQteGrpID, option.productID, id);
                            }
                        }
                    }}
                />
            </td>
            <td>
                {option.sku}&nbsp;
            </td>
            <td>
                {option.name}
                <TextBox
                    value={selectedOption?.description ?? ''}
                    disabled={!checked}
                    valueChangeEvent='blur'
                    onValueChange={(value: string) => {
                        context.updateCustomOptionDescription(prodQteGrpID, option.productID, id, value);
                    }}
                >
                </TextBox>
                {isLast && checked ?
                    <a style={{textDecoration: "none", marginRight: "20px", marginTop: '10px'}}
                       onClick={() => {
                           context.addCustomOption(prodQteGrpID, option.productID);
                       }
                       }><i
                        className="dx-icon-add"></i>Additional Misc. Custom Option</a> : <></>}
            </td>
            <td>
                <img src={option.imageUrl} style={{maxWidth: '30px'}}/>
            </td>
            <td style={{width: '62px'}}>
                <NumberBox
                    min={1}
                    style={{width: '60px'}}
                    showSpinButtons={true}
                    value={selectedOption?.qty ?? 0}
                    disabled={!checked}
                    valueChangeEvent='blur'
                    format={'fixedPoint'}
                    onValueChanged={(e) => {
                        if (e.event) {
                            context.updateCustomOption(prodQteGrpID, option.productID, id, e.value ?? undefined)
                        }
                    }}
                >
                    <Validator>
                        <RequiredRule message={"Quantity must be set and greater than 0"}></RequiredRule>
                    </Validator>
                </NumberBox>
            </td>
            <td style={{width: '42px'}}>
                {option.uom}
            </td>
        </tr>
    )
}
